import React from 'react';

const Vue_BuiltIn_Elements = () => {
  return (
    <div>
      <h1>Vue_BuiltIn_Elements Component</h1>
      <p>This is the Vue_BuiltIn_Elements tutorial page.</p>
    </div>
  );
}

export default Vue_BuiltIn_Elements;
